import { AppAudioPlayer, SoundEffectKeys } from "../../audio/AppAudioPlayer";
import { IShowable } from "../../interfaces/IShowable";
import { ScreenManager, ScreenManagerEvents } from "../../managers/ScreenManager";
import { ScreenOrientationType } from "../../utils/GetOrientation";
import { LoaderFileKeys } from "../constant/AppConstants";
import { OptionsDataManager } from "../managers/OptionsDataManager";
import { AppSettings } from "../managers/AppSettings";
import { LayoutDataManager } from "../managers/LayoutDataManager";
import { AppTimings } from "../data/AppConstants";


export enum ToggleState {
    ON, // toggle on = expanded view
    OFF // toggle off = contracted view
}

type BgStateProps = {
    style: Phaser.Types.GameObjects.Graphics.Styles;
    width: number;
    height: number;
    radius: Phaser.Types.GameObjects.Graphics.RoundedRectRadius;
}

// type OrientationProps = {
//     /**
//      * Container pivot; align container content along (0,0) in this direction
//      */
//     pivot: ContainerPivot,
// }

// export enum ContainerPivot {
//     BOTTOM_LEFT,
//     TOP_RIGHT
// }

/**
 * Table component view with:
 * - Custom toggle hitArea/button (not a generic labelToggle or iconToggle)
 * - header area, visible always
 * - content area, visible only when toggled on (mask in container = bad idea, so just 'move x/y in from side')
 */
export class TableToggleComponentView 
    extends Phaser.GameObjects.Container
    implements IShowable
{
    // asset instances
    public grBg: Phaser.GameObjects.Graphics;
    public txtLabel: Phaser.GameObjects.Text;
    public conContent: Phaser.GameObjects.Container;
    public imgArrow: Phaser.GameObjects.Image;
    public bgHitArea: Phaser.Geom.Rectangle;
    // private pivot: ContainerPivot;
    protected bgRectRadius: number = 30;

    // constants/settings
    protected bgPropsOff: BgStateProps = {
        style: { 
            // lineStyle: { width: 16, color: 0x000000, alpha: 0.8 },
            fillStyle: { color: 0x000000, alpha: 0.8 },
        },
        width: 400,
        height: 200,
        radius: { tl: 0, tr: this.bgRectRadius, br: this.bgRectRadius, bl: 0 },
    }
    protected bgPropsOn: BgStateProps = {
        style: {
            // lineStyle: { width: 16, color: 0x000000, alpha: 0.8 },
            fillStyle: { color: 0x000000, alpha: 0.8 },
        },
        width: 430,
        height: 560,
        radius: { tl: 0, tr: this.bgRectRadius, br: this.bgRectRadius, bl: 0 },
    }
    // protected orientLandscapeProps: OrientationProps = {
    //     pivot: ContainerPivot.BOTTOM_LEFT
    // }
    // protected orientPortraitProps: OrientationProps = {
    //     pivot: ContainerPivot.TOP_RIGHT
    // }
    
    // state
    protected toggleState: ToggleState;
    protected isShowing: boolean = false;
    // protected showableTween:Phaser.Tweens.Tween;


    public Init(): void
    {
        this.bgHitArea = new Phaser.Geom.Rectangle();

        this.Reset();
    }

    public Reset(): void
    {
        this.toggleState = ToggleState.OFF;
    }

    public Build(): void
    {
        // bg
        this.grBg = this.scene.make.graphics({
            x: 0, 
            y: 0,
            // lineStyle: this.bgPropsOff.style.lineStyle,
            fillStyle: this.bgPropsOff.style.fillStyle,
        });
        this.add(this.grBg);

        // label
        this.txtLabel = this.scene.make.text({
            style:{
                color: "#fff",
                fontSize: LayoutDataManager.GetSharedData().table.toggleComponentView.label.fontSize + "px",
                align: "center", 
                fontFamily: AppSettings.fontFamilies.MontserratBold,
                metrics: AppSettings.metrics.montserratBold55,
            }
        });
        this.txtLabel.setOrigin(0.5);
        this.add(this.txtLabel);

        // arrow
        this.imgArrow = this.scene.make.image({key:LoaderFileKeys.ui, frame:"arrow_small.png"});
        this.imgArrow.setOrigin(0.5);
        this.add(this.imgArrow);

        // content container
        this.conContent = this.scene.make.container({});
        this.add(this.conContent);
    }

    public Show(animated: boolean = true): void
    {
        // console.log("TablePopupWindow::Show; animated=", animated);

        // this.SetInteractive(true);

        // kill tweens

        // if (this.showableTween != undefined) {
        //     this.showableTween.stop();
        //     if (this.showableTween.destroy != undefined) this.showableTween.destroy();
        //     this.scene.tweens.killTweensOf(this);
        // }

        this.RegisterListeners();

        // reset
        // this.scale = 0;
        this.alpha = 0;

        // if animate
        let genericShowDuration = OptionsDataManager.GetTiming(AppTimings.genericShowDuration);
        // genericShowDuration = 5000;
        if (animated) {
            // this.showableTween = 
            this.scene.tweens.add({
                targets: this,
                alpha: 1,
                // scale: 1,
                duration: genericShowDuration,
                ease: AppSettings.ease.genericShowHideEase,
            })
        }
        else {
            //
            this.alpha = 1;
            // this.scale = 1;
        }
        this.isShowing = true;
    }

    public Hide(animated: boolean = true): void
    {
        // console.log("PopupBase::Hide; animated=", animated);

        // this.SetInteractive(false);

        this.UnRegisterListeners();

        // kill tweens
        // if (this.showableTween != undefined) {
        //     this.showableTween.stop();
        //     if (this.showableTween.destroy != undefined) this.showableTween.destroy();
        //     this.scene.tweens.killTweensOf(this);
        // }

        // ref
        
        // if animate
        let genericHideDuration = OptionsDataManager.GetTiming(AppTimings.genericHideDuration);
        // genericHideDuration = 5000;
        if (animated) {
            // this.showableTween = 
            this.scene.tweens.add({
                targets: this,
                alpha: 0,
                // scale: 0,
                duration: genericHideDuration,
                ease: AppSettings.ease.genericShowHideEase,
            })
        }
        else {
            // 
            this.alpha = 0;
            // this.scale = 0;
        }
        this.isShowing = false;
    }

    public IsShowing(): boolean
    {
        return this.isShowing;
    }

    protected RegisterListeners(): void
    {
        this.grBg.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.Toggle, this);
    }

    protected UnRegisterListeners(): void
    {
        this.grBg.off(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.Toggle);
    }

    protected Toggle(): void
    {
        AppAudioPlayer.PlaySfx(SoundEffectKeys.click3);

        this.toggleState = this.toggleState == ToggleState.ON ? ToggleState.OFF : ToggleState.ON;
        // orientation didnt hcange, but this also refreshes from toggle state change
        const curOrientation: ScreenOrientationType = ScreenManager.GetOrientation();
        this.UpdateViewFromOrientationChange(curOrientation);
    }

    /**
     * Add listeners to RESIZE/ORIENTATION_CHANGE/'what have you'
     */
    public PostBuild(): void
    {
        ScreenManager.GetEventEmitter().on(ScreenManagerEvents.ORIENTATION_CHANGE, this.UpdateViewFromOrientationChange, this);
        
        // EDIT: refresh view as reaction to @see SetData()
        // const curOrientation: ScreenOrientationType = ScreenManager.GetOrientation();
        // this.OnOrientationChange(curOrientation);

        // oberride in subclass
    }

    public SetData():void
    {
        // override in subclass
    }

    /**
     * 'Change' (internal) view to fit specific orientation
     * NOTE: Handle RESIZE/OnResize, eg reposition of the total/whole component, in parent
     * @param newOrientation 
     */
    protected UpdateViewFromOrientationChange(newOrientation: ScreenOrientationType): void
    {
        // override in subclass
    }
}